<template>
<div class="pk-about-container">
<p class="title">About eLaterna</p>
<p><span style="font-weight: 700;">eLaterna – Historical Art of Projection</span> is a research platform developed at the University of Trier, by the <span style="font-style: italic;">Department of Media Studies</span> and the <span style="font-style: italic;">Trier Center for Digital Humanities</span> (TCDH). It has been created within the research project <span style="font-style: italic;">The Fundamentals of Digitalisation of Works in the Historical Art of Projection</span> which was funded by the German Research Foundation (DFG / 2014-2017; project leaders Claudine Moulin / Martin Loiperdinger).</p>

<p>The research platform provides a major basis and digital tools to understand and to explore the history of the magic lantern, the screen and the art of projection in historical context.
</p>
<p>eLaterna wants to encourage collectors, researchers and show people to participate in collaborative projects. The two main resources <span style="font-style: italic;">eLaterna Archive</span> and <span style="font-style: italic;">eLaterna Companion</span> have been published in June 2018 as beta-versions.
</p>
<p>
<p>Contact: elaterna@uni-trier.de
<p>
<p style="line-height: 28px;"><span style="font-weight: bold">Credits</span><br/>
Concept and curation: Ludwig Vogl-Bienek<br/>
Design and programming: Roland Dahm, Yu Gan, Li Sheng<br/>
Coordination: Thomas Burch, Martin Loiperdinger, Claudine Moulin<br/>
Assistant editors: Lydia Jakobs, Daniela Müller-Kolb, Sarah Woike<br/>
Assistants: Nora Westphal, Senta Zickwolf<br/>
</p>


</div>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  name: 'About',
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('About');
    }
  },
  computed: {
  }});


</script>


<style lang="scss" scoped>
.pk-about-container {
  width: 700px;
  padding-top: 50px;
  margin-left: calc((100vw - 700px) / 2);
  // font-family: 'Times New Roman', Times, serif;
  .title {
    font-weight: 700;
    font-size: 1.5em;
    color: #337ab7;
  }
}
</style>